import { render, staticRenderFns } from "./RegistrationDataTable.vue?vue&type=template&id=ab4f73e6&scoped=true&"
import script from "./RegistrationDataTable.vue?vue&type=script&lang=js&"
export * from "./RegistrationDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDataTable.vue?vue&type=style&index=0&id=ab4f73e6&prod&scoped=true&lang=css&"
import style1 from "./RegistrationDataTable.vue?vue&type=style&index=1&id=ab4f73e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f73e6",
  null
  
)

export default component.exports